const correctDateFormat = (weekDate: string) =>
  weekDate.includes('-') ? weekDate.split('-').join('/') : weekDate;

export default correctDateFormat;
